export const preferences = {
  allowsExchanges: 'allows_exchanges',
  allowsRefunds: 'allows_refunds',
  allowedExchangeMethods: 'allowed_exchange_methods',
  allowsOrderRecovery: 'allows_order_recovery',
  skipSingleRefundMethodStep: 'skip_single_refund_method_step',
  exchangeOrdersAutomaticCreation: 'exchange_orders_automatic_creation',
  allowsInstantExchanges: 'allows_instant_exchanges',
  instantExchangeOrdersAutomaticCreation: 'instant_exchange_orders_automatic_creation',
  exchangeOrdersSendProviderNotification: 'exchange_orders_send_provider_notification',
  instantExchangeOrdersSendProviderNotification: 'instant_exchange_orders_send_provider_notification',
  productVariantExchangeRecommendationType: 'product_variant_exchange_recommendation_type',
  productVariantExchangeRecommendationValue: 'product_variant_exchange_recommendation_value',
  returnCancelDeadlineDays: 'return_cancel_deadline_days',
  manageRestock: 'manage_restock',
}

export const exchangeMethods = {
  otherProducts: 'other_products',
  sameProductVariants: 'same_product_variants',
  otherProductVariants: 'other_product_variants',
}

export const tabList = {
  store: 'Tienda',
  branding: 'Branding',
  orderTrackingPage: 'Página de seguimiento del pedido',
  visibilityCriterionDetail: 'Nuevo criterio de visibilidad',
  returnsPortal: 'Portal devoluciones',
  returnsPortalChildren: {
    configuration: 'General',
    copies: 'Textos',
  },
  storeEn: 'Store',
  refunds: 'Reembolsos',
  refundsEn: 'Refunds',
  returnPolicy: 'Política de devoluciones',
  returnPolicyEn: 'Return policy',
  newException: 'Nueva excepción',
  newExceptionEn: 'New Exception',
  reasons: 'Motivos devolución',
  reasonsEn: 'Return reasons',
  reasonsChildren: {
    list: 'Motivos',
    settings: 'Configuración',
  },
  reasonsDetail: 'Nuevo motivo de devolución',
  reasonsDetailEn: 'new return reason',
  logisticsEn: 'Logistics',
  logistics: 'Logística',
  logisticsDetail: 'Nuevo método de devolución',
  availabilityCriterionDetail: 'Criterio de disponibilidad',
  returnInstructionsDetail: 'Instrucciones devolución',
  logisticsDetailEn: 'New return method',
  locationDetail: 'Nueva ubicación',
  shippingMethodDetail: 'Nuevo método de envío',
  policyRuleDetail: 'Nueva regla',
  copies: 'Textos',
  copiesEn: 'Copies',
  billing: 'Facturación',
  billingEn: 'Billing',
  extras: 'Widgets',
  extrasEn: 'Widgets',
  extrasChildren: {
    reveniWidget: 'Reveni widget',
    shippingWidget: 'Widget envíos',
    sizingWidget: 'Widget de tallas',
    bracketingWidget: 'Widget bracketing',
    topBannerWidget: 'Widget top banner',
    tryOnWidget: 'Try-on widget',
  },
  communications: 'Comunicaciones',
  communicationsEn: 'Communications',
  communicationsGeneral: 'General',
  communicationsGeneralEn: 'General',
  emailTemplates: 'Plantillas de correo',
  emailTemplatesEn: 'Email templates',
  emailTemplateDetail: 'Editar plantilla',
  themes: 'Estilos',
  themesEn: 'Themes',
  users: 'Usuarios',
  usersEn: 'Users',
  userDetail: 'Nuevo usuario',
  userDetailEn: 'New user',
  group: 'Nuevo grupo',
  groupEn: 'New group',
  integrations: 'Integraciones',
  integrationsEn: 'Integrations',
  inventory: 'Inventario',
  general: 'General',
  packagingDetail: 'Nuevo embalaje',
  returnProtection: 'Return Protection',
  returnProtectionChildren: {
    general: 'General',
    appearance: 'Apariencia',
  },
}

export const tabIds = {
  store: 'store',
  returnPolicy: 'returnPolicy',
  branding: 'branding',
  orderTrackingPage: 'orderTrackingPage',
  returnsPortal: 'returnsPortal',
  billing: 'billing',
  policy: 'policy',
  reasons: 'reasons',
  refunds: 'refunds',
  logistics: 'logistics',
  copies: 'copies',
  extras: 'extras',
  communications: 'communications',
  users: 'users',
  group: 'group',
  integrations: 'integrations',
  inventory: 'inventory',
  returnProtection: 'returnProtection',
}

export const directDebitTypes = {
  BACS: 'bacs',
  SEPA: 'sepa',
}

export const sectionTypes = {
  returnPolicy: 'return_preferences',
  refundMethods: 'refund_methods',
  communications: 'communication_preferences',
  email_templates: 'email_templates',
  theme: 'theme',
  emailTheme: 'email_theme',
}

export const configurationTypes = {
  merchant: 'merchant',
  store: 'store',
  returnsPortal: 'returnsPortal',
}

export const taxonomyTypeValues = {
  category: 'category',
  productType: 'product_type',
  collection: 'collection',
}
